<ul class="breadcrumb">
  <li
    *ngFor="let breadcrumb of breadcrumbs; let i = index"
    class="breadcrumb-item"
  >
    <ng-container *ngIf="i < breadcrumbs.length - 1; else unlinked">
      <a routerLink="{{ breadcrumb.url }}" class="breadcrumb-link">
        {{ breadcrumb.label | translate }}
      </a>
    </ng-container>

    <ng-template #unlinked>
      <span class="font-weight-bold font-size-14">
        {{ breadcrumb.label | translate }}
      </span>
    </ng-template>
  </li>
</ul>
